// removed by extract-text-webpack-plugin
module.exports = {"item_lg":"src-components-NavigationItem----navigationitem-module---item_lg---34Qfg","item":"src-components-NavigationItem----navigationitem-module---item---1158x","overlay":"src-components-NavigationItem----navigationitem-module---overlay---19zyz","img":"src-components-NavigationItem----navigationitem-module---img---2geeR","title":"src-components-NavigationItem----navigationitem-module---title---2HQs1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NavigationItem/navigationitem.module.scss
// module id = 42
// module chunks = 195451945045015 204899606439113 234676073312213